export default __webpack_public_path__ + "static/media/news-item.b93f17a7.png";